(() => {
  const enhanceManualFilters = root => {
    root.querySelectorAll('[data-nova-manual-filter]:not([data-nova-ready])').forEach(form => {
      form.dataset.novaReady = 'true';
      form.addEventListener('input', event => event.stopPropagation());
      form.addEventListener('theme:range:update', event => event.stopPropagation());
    });
  };

  enhanceManualFilters(document);
  document.addEventListener('shopify:section:load', event => enhanceManualFilters(event.target));

  if (customElements.get('nova-collection-sort')) return;
  customElements.define('nova-collection-sort', class extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      this.onChange = event => {
        const collection = this.closest('collection-component');
        const manualForm = collection?.querySelector('[data-nova-manual-filter]');
        const input = collection?.querySelector('[data-nova-sort-input]');
        if (manualForm) {
          if (this.classList.contains('nova-collection-sort--mobile') && input) {
            input.value = this.select.value;
          } else {
            this.querySelector('form')?.requestSubmit();
          }
          return;
        }
        const controller = collection?.querySelector('collection-filters-form');
        if (!controller?.submitForm || !input) {
          this.querySelector('form')?.requestSubmit();
          return;
        }
        input.value = this.select.value;
        collection.querySelectorAll('[data-nova-sort]').forEach(select => { select.value = input.value; });
        controller.submitForm(event);
      };
      this.select.addEventListener('change', this.onChange);
    }
    disconnectedCallback() {
      this.select?.removeEventListener('change', this.onChange);
    }
  });
})();
